var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportCcdIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76685 9.7334L9.90018 11.8667L12.0335 9.7334",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76685 9.7334L9.90018 11.8667L12.0335 9.7334",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 3.33325V11.8083",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 10.1499C16.6666 13.8332 14.1666 16.8166 9.99992 16.8166C5.83325 16.8166 3.33325 13.8332 3.33325 10.1499",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCcdIcon);
export default __webpack_public_path__ + "static/media/import_ccd_icon.92bffb31232befca8566a2ce691185bd.svg";
export { ForwardRef as ReactComponent };